import React from "react";
import { createRoot } from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/fonts/VerizonNHGTX-Bold.ttf";
import "./assets/fonts/VerizonNHGTX-Regular.ttf";
import { Provider } from "react-redux";
import store from "./store";
import { PersistGate } from "redux-persist/integration/react";
import NewApp from "./NewApp.js";
import { persistStore } from "redux-persist";
import { CookiesProvider } from "react-cookie";

const root = createRoot(document.getElementById("root"));
let persistor = persistStore(store);

root.render(
  <Provider store={store}>
     <PersistGate loading={null} persistor={persistor}>
      <CookiesProvider defaultSetOptions={{ path: '/' }}>
         <NewApp />
      </CookiesProvider>
     </PersistGate>
  </Provider>
);
